// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"8d9ceb0f","268":"1643e28e","403":"59cc89b0","551":"3c874688","638":"01ff713e"}[chunkId] + ".chunk.js";
};